<template>
	<div>
		<BaseTable
			:actions="{
				add: false,
				import: false,
				export: false,
				operation: false,
			}"
			:selection="false"
			:data="data"
			:columns="columns"
			:total="total"
			:pageNum="pageNum"
			:pageSize="pageSize">
			<template slot="header-left">
				<el-button size="small" icon="el-icon-plus" type="primary" @click="handerAdd">新增变动</el-button>
			</template>

			<template #changeSubType="{ row }">
				<el-tag type="success" size="small">{{ $menu.getLabel('AssetChangeType', row.changeSubType) }}</el-tag>
			</template>
			<template #status="{ row }">
				<el-tag type="success" size="small">{{ $menu.getLabel('AssetPlanStatus', row.status) }}</el-tag>
			</template>
		</BaseTable>
	</div>
</template>

<script>
	export default {
		name: 'AssetLedgerDynamicRecording',
		props: {
			data: {
				type: Array,
				default: () => [],
			},
		},
		data() {
			return {
				total: 0,
				pageNum: 1,
				pageSize: 10,
				columns: [
					{ prop: 'assetId', label: '变动编号' },
					{ prop: 'changeSubType', label: '变动类型', slot: 'changeSubType' },
					{ prop: 'changeDate', label: '变动日期' },
					{ prop: 'changeAfter', label: '变动内容' },
					{ prop: 'updater', label: '操作人' },
					{ prop: 'status', label: '状态', slot: 'status' },
				],
			};
		},
		methods: {
			handerAdd() {},
		},
	};
</script>

<style scoped lang="scss">
	.table-card {
		margin-bottom: 15px;
	}
</style>
